module.exports = __webpack_public_path__ + "static/kinesis-cover-2bc24102f532e7ad27ba846d7cfb2f4a.png";